export default __webpack_public_path__ + "static/media/headphones-sound-wave-icon.6ec0a30c.svg";